import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import * as sharedGuards from './shared/guards';
import * as coreGuards from './core/guards';
import * as coreResolvers from './core/resolver';
import * as coreContainers from './core/containers';
import { lazyLoad } from './shared/util';
import { PLAYGROUND_ROUTES } from './vista/playground/playground.routes';


const appRoutes: Routes = [
  {
    path: '',
    canActivate: [
      sharedGuards.DebugGuard,
      coreGuards.AuthorizationUserGuard,
      coreGuards.CurrentUserGuard,
    ],
    resolve: [coreResolvers.ConfigServiceInitializerResolver],
    children: [
      {
        path: 'clients',
        loadChildren: () => lazyLoad(
          () => import('./modules/+client/client.module').then((m) => m.ClientModule),
          'Client Module'
        ),
        canActivate: [coreGuards.PermissionGuard],
        data: { viewPermission: 'clientsModule.overall', title: 'Clients' },
      },
      {
        path: 'charters',
        loadChildren: () => lazyLoad(
          () => import('./modules/+charter/charter.module').then((m) => m.CharterModule),
          'Charter Module'
        ),
        canActivate: [coreGuards.PermissionGuard],
        data: {
          viewPermission: 'charterSalesModule.overall',
          title: 'Charters',
        },
      },
      {
        path: 'marketplace',
        loadChildren: () => lazyLoad(
          () => import('./modules/+marketplace/marketplace.module').then((m) => m.MarketplaceModule),
          'Marketplace Module'
        ),
        canActivate: [coreGuards.PermissionGuard],
        data: {
          viewPermission: 'marketplaceModule.overall',
          title: 'Marketplace',
        },
      },
      {
        path: 'resource-mgmt',
        loadChildren: () => lazyLoad(
          () => import('./modules/+resource-mgmt/resource-mgmt.module').then((m) => m.ResourceMgmtModule),
          'Resource Mgmt'
        ),
        canActivate: [coreGuards.PermissionGuard],
        data: {
          viewPermission: 'resourceModule.overall',
          title: 'Resources',
        },
      },
      {
        path: 'sales',
        loadChildren: () => lazyLoad(
          () => import('./modules/+sales/sales.module').then((m) => m.SalesModule),
          'Sales Module'
        ),
        canActivate: [coreGuards.PermissionGuard],
        data: {
          viewPermission: 'salesModule.overall',
          title: 'Sales',
        },
      },
      {
        path: 'sourcing',
        loadChildren: () => lazyLoad(
          () => import('./modules/+sourcing/sourcing.module').then((m) => m.SourcingModule),
          'Sourcing'
        ),
        canActivate: [coreGuards.PermissionGuard],
        data: {
          viewPermission: 'sourcingModule.overall',
          title: 'Sourcing',
        },
      },
      {
        path: 'task-mgmt',
        loadChildren: () => lazyLoad(
          () => import('./modules/+task-mgmt/task-mgmt.module').then((m) => m.TaskMgmtModule),
          'Task mgmt'
        ),
        canActivate: [coreGuards.PermissionGuard],
        data: {
          viewPermission: 'taskMgmtModule.overall',
          title: 'Task Management',
        },
      },
      {
        path: '',
        component: coreContainers.LandingComponent,
        resolve: [coreResolvers.LandingResolver],
        data: {
          viewPermission: 'clientsModule.overall',
          redirect: 'clients',
        },
      },
      // { path: 'login', component: coreContainers.VersionHistoryPageComponent },

      // { path: '', redirectTo: '/clients', pathMatch: 'full' }
    ],
  },
  { path: 'access-denied', component: coreContainers.AccessDeniedPageComponent },
  // Outside the guarded children, and empty outside `local`/`dev` — see playground.routes.ts.
  ...PLAYGROUND_ROUTES,
  {
    path: '**',
    redirectTo: 'clients',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
